/**
 * Basketeurope Tailwind child front-end JS.
 * Parent already initialises Alpine + stores. Add child-specific
 * components / Alpine.data() / Alpine.store() here.
 */

// Example:
// import Alpine from 'alpinejs'
// Alpine.data('myChildComponent', () => ({ open: false }))
